module.exports = __webpack_public_path__ + "img/17_76.824790aa.png";